const FIREBASE_REGION = "europe-west1"

export const CLOUD_FUNCTIONS_URL = `https://${FIREBASE_REGION}-a4l-messenger.cloudfunctions.net`
